import "./action-buttons.css";

const ActionButtons = ({ onSave, onDiscard, loading }) => {
  return (
    <div className="action-wrapper">
      <button
        className="btn save-btn"
        onClick={onSave}
        disabled={loading}
      >
        {loading ? (
          <span className="loader"></span>
        ) : (
          <i className="fas fa-save icon"></i>
        )}
        Save
      </button>

      <button
        className="btn discard-btn"
        onClick={onDiscard}
      >
        <i className="fas fa-times icon"></i>
        Discard
      </button>
    </div>
  );
};

export default ActionButtons;